const announcementBars = document.querySelectorAll('.announcement-bar');
let activeIndex = 0;

// This function will be responsible for the hiding/showing logic
function updateBars() {
    announcementBars.forEach(function(bar, index) {
        if (index === activeIndex) {
            bar.classList.remove('visually-hidden');
        } else {
            bar.classList.add('visually-hidden');
        }
    });

    activeIndex = (activeIndex + 1) % announcementBars.length;
}

// Call the function immediately to run on first render
updateBars();

// Then run the function every 3000ms
setInterval(updateBars, 3000);